module.exports = __webpack_public_path__ + "img/bg39.ff50dc1d.png";